import { render, staticRenderFns } from "./DmrScreen.vue?vue&type=template&id=fda5e6ee&scoped=true"
import script from "./DmrScreen.vue?vue&type=script&lang=js"
export * from "./DmrScreen.vue?vue&type=script&lang=js"
import style0 from "./DmrScreen.vue?vue&type=style&index=0&id=fda5e6ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda5e6ee",
  null
  
)

export default component.exports